const global = window

// Requête
inputs.behavior.query = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.query) {
        input.click(function(event) {
            event.preventDefault();
            if (input.data('hold') || input.hasClass('cell--open')) return false;
            ajaxForm(data.query);

            //callAPI(data.query.method, data.query.url, data.query.data, function () {
            //    if (event.type === 'click') {
                    /*
                    if (parent && parent.closeWindow) parent.closeWindow();
                    inputWindow.find('input, select, textarea').filter(':visible').val('').change();
                    if (apiFormData && apiFormData.ajax) {
                        apiFormData.reload();
                    }
                    */
            //    }
            //});
        })
    }
    return data
}
